import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Seo = ({ title, description, image, type = "website", url }) => {
  const location = useLocation();
  const fullUrl = url || `${window.location.origin}${location.pathname}`;
  const ogImage = image || `${window.location.origin}/default-ogp.png`;
  const metaDescription = description || title;

  useEffect(() => {
    document.title = title;

    // description
    const descTag = document.querySelector("meta[name='description']");
    if (descTag) {
      descTag.setAttribute("content", metaDescription);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = metaDescription;
      document.head.appendChild(meta);
    }

    // OGP
    const ogTags = [
      { property: "og:title", content: title },
      { property: "og:description", content: metaDescription },
      { property: "og:type", content: type },
      { property: "og:url", content: fullUrl },
      { property: "og:image", content: ogImage },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // Twitterカード
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: metaDescription },
      { name: "twitter:image", content: ogImage },
    ];

    twitterTags.forEach(({ name, content }) => {
      let tag = document.querySelector(`meta[name='${name}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // 構造化データ（Article 例）
    const ldJsonId = "structured-data";
    let ldJson = document.getElementById(ldJsonId);
    if (!ldJson) {
      ldJson = document.createElement("script");
      ldJson.type = "application/ld+json";
      ldJson.id = ldJsonId;
      document.head.appendChild(ldJson);
    }
    ldJson.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: title,
      description: metaDescription,
      url: fullUrl,
      image: ogImage,
      author: {
        "@type": "Organization",
        name: "Mind Threat",
      },
      datePublished: new Date().toISOString(),
    });
  }, [title, metaDescription, ogImage, type, fullUrl]);

  return null; // DOM に何も表示しない
};

export default Seo;
